import template from './general-business-details.html';
import controller from './general-business-details.controller';

let generalBusinessDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default generalBusinessDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/general-business-details/general-business-details.component.js